import React from 'react'
import Banner from "./banner"
import RegisterForm from "./registerform"

function index() {
  return (
    <div className='register'>
    <Banner/>
    <RegisterForm />
    </div>
  )
}

export default index